"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
var _action_types = require("../../constants/action_types");
function reset() {
  return {
    type: _action_types.AUTHENTICATION_RESET_TYPE
  };
}